import React, { useEffect, useState } from 'react'

const FooterComponent = () => {

    const [isPoep, setIsPoep] = useState(false)

    useEffect(() => {
        const source = sessionStorage.getItem('source');
        setIsPoep(source === 'POEP' || source === "null" ? true : false)
    }, [])


    return (
        <footer className="bg-white rounded-lg dark:bg-gray-800 w-full">
            <div className="w-full mx-auto p-4 flex flex-col md:flex-row justify-center items-center">
                <div className="text-justify text-sm text-gray-500 sm:text-justify dark:text-gray-400 flex-grow mb-0 md:mb-0 md:mr-4 flex items-center md:w-2/3">
                    <div>
                        Novo Nordisk<span className='align-super text-xs'>®</span> es una marca registrada propiedad de Novo Nordisk A/S. Material revisado y aprobado por la Dirección de Asuntos Médicos y Regulatorios de Novo Nordisk<span className='align-super text-xs'>®</span>. Para uso exclusivo del profesional de la salud y en Guatemala es para uso exclusivo del profesional médico. Si tiene alguna solicitud de información médica escríbanos a medicalinfo_clat@novonordisk.com <span className='fw-bold' style={{ color: "#001965" }}>{isPoep ? "CLA25OB00058" : "CLA25OB00037"}</span>
                    </div>
                </div>
                <div className="flex-shrink-0 flex items-center">
                    <img src="/images/icons/logo-novo-blue.png" className="h-20" alt="Flowbite Logo" />
                </div>
            </div>
        </footer>
    )
}

export default FooterComponent
